import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import MapService from '@/services/mapService';
export default {
  name: 'IsFMBuildingMgmtTiles',
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    stateAggregationValue() {
      return this.isStateAggregation(this.state);
    },
    stateAggregationValidText() {
      return `${this.stateAggregationValue.value}${this.stateAggregationValue.unit}`;
    },
    stateAggregationValidTextFontSize() {
      if (this.stateAggregationValidText.length <= 3) {
        return 25;
      } else if (this.stateAggregationValidText.length <= 5) {
        return 22;
      } else if (this.stateAggregationValidText.length <= 7) {
        return 18;
      }
      return 16;
    },
    successColor() {
      return MapService.markerColor('success');
    }
  },
  methods: {
    localizeDate(item) {
      return localizeDate(item);
    },
    isBoolean(item) {
      return item.properties.valueType && item.properties.valueType === 'boolean';
    },
    isPercentage(item) {
      if (item.value && item.value.value !== null && item.properties.unit) {
        // TODO: cover other cases where the word is written out?
        // what about multi-language then
        if (item.properties.unit === '%') {
          return true;
        }
      }
      return false;
    },
    isTemperature(item) {
      return item.properties.unit === '°C' || item.properties.unit === '°F';
    },
    isStateAggregation(item) {
      if (item.properties.unit === 'State-Aggregation') {
        if (`${item.value.value}`.trim() === '') {
          return true;
        }
        if (typeof item.value.value !== 'object') {
          const jsonObj = JSON.parse(item.value.value);
          return jsonObj;
        }
        return item.value.value;
      }
      return false;
    }
  }
};